// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonOutline_button__1FInJ","link":"ButtonOutline_link__2M95w"};